package fr.manyverse.app.domain.validation

import fr.manyverse.app.domain.error.DomainException
import fr.manyverse.app.domain.error.ValidationError

object FeedbackValidator {
    const val MAX_FEEDBACK_LENGTH = 5000

    fun validate(message: String): DomainException? {
        if (message.trim().isEmpty()) {
            return ValidationError("Feedback message cannot be empty")
        }

        if (message.length > MAX_FEEDBACK_LENGTH) {
            return ValidationError("Feedback message too long (max $MAX_FEEDBACK_LENGTH characters)")
        }

        return null
    }
}
